import _ from "lodash";
import { push } from "react-router-redux";
import axios from "axios";

import { localRequest } from "../../apiUtils";
import IMeta from "models/IMeta";
import { setLoading } from "../app/actions";
import URLS from "constants/urlConstants";
import { getOptions } from "helpers/common";
import { CUSTOM_SETTINGS } from "constants/.";

export const actionTypes = {
  GET_CULTIVATION_ADVICES_REQUEST: "GET_CULTIVATION_ADVICES_REQUEST",
  GET_CULTIVATION_ADVICES_SUCCESS: "GET_CULTIVATION_ADVICES_SUCCESS",
  GET_CULTIVATION_ADVICES_FAILURE: "GET_CULTIVATION_ADVICES_FAILURE",
  GET_CULTIVATION_ADVICE_REQUEST: "GET_CULTIVATION_ADVICE_REQUEST",
  GET_CULTIVATION_ADVICE_SUCCESS: "GET_CULTIVATION_ADVICE_SUCCESS",
  GET_CULTIVATION_ADVICE_FAILURE: "GET_CULTIVATION_ADVICE_FAILURE",
  SAVE_CULTIVATION_ADVICE_REQUEST: "SAVE_CULTIVATION_ADVICE_REQUEST",
  SAVE_CULTIVATION_ADVICE_SUCCESS: "SAVE_CULTIVATION_ADVICE_SUCCESS",
  SAVE_CULTIVATION_ADVICE_FAILURE: "SAVE_CULTIVATION_ADVICE_FAILURE",
  REMOVE_CULTIVATION_ADVICES_SUCCESS: "REMOVE_CULTIVATION_ADVICES_SUCCESS",
  REMOVE_CULTIVATION_ADVICES_FAILURE: "REMOVE_CULTIVATION_ADVICES_FAILURE",
  GET_CULTIVATION_SELECT_OPTIONS_REQUEST:
    "GET_CULTIVATION_SELECT_OPTIONS_REQUEST",
  GET_CULTIVATION_SELECT_OPTIONS_SUCCESS:
    "GET_CULTIVATION_SELECT_OPTIONS_SUCCESS"
};

export default class Actions {
  public static getCultivationAdvices(
    meta = {} as IMeta,
    onlyPublished = false
  ) {
    return async (dispatch, getState) => {
      dispatch(request());
      dispatch(setLoading(true));

      const savedMeta = _.get(getState(), "cultivationAdvices.meta", {});

      if (_.isEmpty(meta) && !onlyPublished) {
        meta = savedMeta;
      }

      if (!meta.pageSize) {
        const savedSettings = JSON.parse(
          localStorage.getItem("customSettings") || "{}"
        );
        _.set(
          meta,
          "pageSize",
          _.get(
            savedSettings,
            `${CUSTOM_SETTINGS.myCultivationAdvice}.pageSize`,
            10
          )
        );
      }

      try {
        let subscriptions: string[] = [];
        if (onlyPublished) {
          const { data: allSubscriptions } = await axios.get("NewsLetters");

          subscriptions = _.map(allSubscriptions.value, "Code");
        }
        const { data } = await localRequest.post("teeltadvies/all", {
          ...meta,
          onlyPublished,
          subscriptions: JSON.stringify(subscriptions)
        });
        console.log("Subs:", subscriptions);

        const newMeta = !onlyPublished
          ? {
              ...meta,
              ...data.meta
            }
          : { ...savedMeta, ...data.meta };

        dispatch(success(data.rows, newMeta));
        dispatch(setLoading(false));
      } catch (error) {
        dispatch(failure(error));
        dispatch(setLoading(false));
      }
    };

    function request() {
      return { type: actionTypes.GET_CULTIVATION_ADVICES_REQUEST };
    }
    function success(payload, meta) {
      return {
        type: actionTypes.GET_CULTIVATION_ADVICES_SUCCESS,
        payload,
        meta
      };
    }
    function failure(error) {
      return { type: actionTypes.GET_CULTIVATION_ADVICES_FAILURE, error };
    }
  }

  public static getCultivationAdvice(id) {
    return async dispatch => {
      dispatch(request());
      dispatch(setLoading(true));
      try {
        const { data } = await localRequest.get(`teeltadvies/${id}`);
        dispatch(success(data));
        dispatch(setLoading(false));
      } catch (error) {
        dispatch(failure(error));
        dispatch(setLoading(false));
      }
    };

    function request() {
      return { type: actionTypes.GET_CULTIVATION_ADVICE_REQUEST };
    }
    function success(payload) {
      return { type: actionTypes.GET_CULTIVATION_ADVICE_SUCCESS, payload };
    }
    function failure(error) {
      return { type: actionTypes.GET_CULTIVATION_ADVICE_FAILURE, error };
    }
  }

  public static saveCultivationAdvice(params) {
    return async dispatch => {
      dispatch(request());
      dispatch(setLoading(true));

      try {
        const { data } = await localRequest.post("teeltadvies", params);
        const newsLetter = {
          Code: data._id,
          Date: data.Date,
          Published: data.Status === "published",
          TypeId: data.Type,
          Title: data.Title_nl
        };
        if (data.CnbId === -1) {
          const { data: newsLetterData } = await axios.post(
            "NewsLetters",
            newsLetter
          );
          await localRequest.patch(`teeltadvies/${data._id}`, {
            CnbId: newsLetterData.Id
          });
        } else {
          await axios.patch(`NewsLetters(${data.CnbId})`, newsLetter);
        }

        dispatch(success(data));
        dispatch(setLoading(false));
        dispatch(push(URLS.MY_CULTIVATION_ADVICE_URL));
      } catch (error) {
        dispatch(failure(error));
        dispatch(setLoading(false));
      }
    };

    function request() {
      return { type: actionTypes.SAVE_CULTIVATION_ADVICE_REQUEST };
    }
    function success(payload) {
      return {
        type: actionTypes.SAVE_CULTIVATION_ADVICE_SUCCESS,
        payload
      };
    }
    function failure(error) {
      return { type: actionTypes.SAVE_CULTIVATION_ADVICE_FAILURE, error };
    }
  }

  public static removeCultivationAdvices(ids) {
    return async (dispatch, getState) => {
      dispatch(setLoading(true));

      try {
        await Promise.all(
          ids.map(async id => {
            const { data } = await localRequest.delete(`teeltadvies/${id}`);
            await axios.delete(`NewsLetters(${data})`);
          })
        );
        dispatch(success(getState().cultivationAdvices.items));
        dispatch(setLoading(false));
      } catch (error) {
        dispatch(failure(error));
        dispatch(setLoading(false));
      }
    };

    function success(items) {
      const payload = items.filter(i => !_.includes(ids, i._id));
      return { type: actionTypes.REMOVE_CULTIVATION_ADVICES_SUCCESS, payload };
    }
    function failure(error) {
      return { type: actionTypes.REMOVE_CULTIVATION_ADVICES_FAILURE, error };
    }
  }

  public static getSelectOptions() {
    return async dispatch => {
      dispatch(request());
      try {
        const { data } = await axios.get("NewsLetters/Enums");
        const typeOptions = getOptions(data, "NewsLetterType");
        dispatch(success(typeOptions));
      } catch (error) {
        dispatch(failure(error));
      }
    };

    function request() {
      return { type: actionTypes.GET_CULTIVATION_SELECT_OPTIONS_REQUEST };
    }
    function success(payload) {
      return {
        type: actionTypes.GET_CULTIVATION_SELECT_OPTIONS_SUCCESS,
        payload
      };
    }
    function failure(error) {
      return { type: actionTypes.GET_CULTIVATION_ADVICE_FAILURE, error };
    }
  }
}
